module.exports = __webpack_public_path__ + "img/icon-sb-tip-illustration-128x128.46f4938.svg";